export const uk = {
    'add-clients': 'Изменить доступ к пакету'
};
